export const citations = 'citations';
export const substances = 'substances';
export const reactions = 'reactions';
export const tgitems = 'tgitems';
export const dpitems = 'dpitems';

export const HIT_DATA_FACT_ID = 'HIT_DATA';
export const COMMERCIAL_SUPPLIERS_FACT_ID = 'PRODD';
export const COMMERCIAL_SUPPLIERS_FACT_CHILD_ID = 'PROD';

// Are related to RX-10479 and RX-11382 (feature switch "Enable Sort by Relevance by default"),
// these values will override the default sorting for documents on results page and in batch searches
export const SORT_BY_RELEVANCE_FIELD = 'WEIGHT';
export const SORT_BY_RELEVANCE_ORDER = 'desc';

export const SORT_BY_SIMILARITY_FIELD = 'SIMILARITY';
export const SORT_BY_SIMILARITY_ORDER = 'desc';
export const SORT_BY_SIMILARITY_KEY_WORD = 'similarity';

export const REAXYS_ROOT_DOMAINS = ['.reaxys.com', '.cm-elsevier.com'];
